<template>
  <div class="flex-shrink-0 rounded-full flex items-center justify-center font-bold font-sans" :class="[sizeClass, muted ? 'bg-gray-100 text-gray-400' : 'bg-primary-100 text-primary-700']">
    {{ text }}
  </div>
</template>

<script>
import { initials } from "../securone.helpers";

export default {
  name: "SoAvatar",
  props: {
    name: { type: String, default: "" },
    muted: { type: Boolean, default: false },
    size: { type: String, default: "md" },
  },
  computed: {
    text() {
      return initials(this.name);
    },
    sizeClass() {
      return { sm: "w-6 h-6 text-xxs", md: "w-8 h-8 text-xs", lg: "w-10 h-10 text-sm" }[this.size];
    },
  },
};
</script>
